export const theme = {
  colorPrimary: 'rgb(22, 119, 255)'
}
